export const TYPE_PRATIQUE = {
  affiliation: "affiliation",
  cabinet: "cabinet",
  licence: "licence",
};
